module.exports = __webpack_public_path__ + "img/front.e0a236c3.png";